export default "__VITE_ASSET__xIEOPMwF__"